<template>
    <div id="contendor-principal-zonas" class="container-fluid">
         <!-- <div id="contenedor-encabezados-CZonas" class="text-left">
            <h1>ZONAS</h1>
            LINEA COMENTADA => <h3>Seleccione la opción que desea realizar</h3>
            <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
                <div class="flex-grow-1 pl-3"><h4>Administración de zonas</h4></div>
            </div>
            <div id="contenedor-zonas">
                <div id="mapa-zonas" class="area col-12">
                    LINEA COMENTADA => <h4>Administración de zonas</h4>
                    <div class="d-flex mb-2">
                        <div class="contenedor-color-negro mt-2 col-4">
                            <h5>Zonas registradas</h5>
                            <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;" />
                            <div class="text-right">
                                <div v-if="!mostrarFormulario">
                                    <button type="button" @click="agregarZona" class="btn-sm btn-primary"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar</button>
                                </div> 
                            </div>
                            <CTablaGenericaCedulas v-if="Zonas.length > 0" style="margin-top: 3px;" class="table-responsive"
                                :idDelInput="ID_TABLA_ZONAS"
                                :encabezadosColumnas="encabezadosColumnasZonas"
                                :accionesEnTabla="TABLA_ZONAS_ACCIONES"
                                :listaDeCedulas="Zonas"
                                v-on:accionFuncionEliminar="eventoEliminarZona($event)"
                                v-on:accionesFuncionDeEditar="eventoEditarZona($event)"></CTablaGenericaCedulas>
                            <div v-if="Zonas.length < 1 && !cargandoZonas" class="contenedor-zonas-vacias" >
                                <div class="text-center">
                                    <i class="fas fa-map-marked-alt mb-4" style="font-size: 9em;"></i>
                                    <h6>No existen zonas agregadas</h6>
                                </div>
                            </div>
                            <div v-if="cargandoZonas" class="contenedor-cargando mt-2" style="height: 300px ;">
                                <div class="text-center">
                                    <i class="fas fa-spinner fa-spin fa-5x"></i>
                                    <h4 class="mt-4">Cargando zonas</h4>
                                </div>
                            </div>
                        </div>
                        <div v-show="!mostrarFormulario" class="mt-2 col-8 pl-4 pr-0">
                            <div id="contenedor-mapa">
                                <CMapaDePoligonos
                                    :idMapa="MAPA_ZONAS"
                                    :posicionOrigenMapa="posicionOrigenMapa"
                                    :cargandoMapa="cargandoZonas"
                                    :acercamientoInicialMapa="acercamientoInicialMapa"
                                    :colorZona="colorZona"
                                    :polygonoEditar="MAPA_ZONAS_POLIGONO_EDITAR"
                                    :ref="REF_MAPA_ZONAS"
                                    :key="'MAPA-INICIO-' + mapaInicio.contRender"
                                    ></CMapaDePoligonos>
                            </div>
                        </div>
                        <div v-show="mostrarFormulario" class=" mt-2 col-8 pl-4 pr-0">
                            <div class="contenedor-color-negro">
                                <div v-if="mostrarFormulario && !cargandoZonas">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h5>Paso 1: Llena el formulario de registro de zona</h5>
                                        <button @click="eventoCerrarFormulario" id="btn-cerrar-formulario-alta-zona" class="close"><i class="fas fa-times-circle " style="font-size: 25px;"></i></button>
                                    </div>
                                    <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;" />
                                    <h6>1)  Nombre de la zona (*)&nbsp;
                                        <i v-if="informarCamposVacios && this.campoRequeridoEsValido(nombreZona)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="informarCamposVacios && !this.campoRequeridoEsValido(nombreZona)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                                    </h6>
                                    <input v-model="nombreZona" type="text" id="nombre-zona" :class="[(informarCamposVacios && !this.validacionAltaDeZona()) ? 'form-control border border-danger' : 'form-control']" placeholder="Ingrese nombre de la zona" />
                                    <hr />
                                    <h6>2)  Seleccione los notificadores (opcional)</h6>
                                    <CTablaGenericaCedulas v-if="listaDeNotificadores.length > 0 && !cargandoNotificadores" style="margin-top: 3px;" class="table-responsive"
                                        :idDelInput="ID_TABLA_NOTIFICADORES"
                                        :encabezadosColumnas="encabezadosColumnasNotificadores"
                                        :accionesEnTabla="TABLA_NOTIFICADORES_ACCIONES"
                                        :listaDeCedulas="listaDeNotificadores"
                                        :listaCedulasSeleccionadas="listaCedulasSeleccionadasEdicion"
                                        v-on:elementosSeleccionados="notificadoresSeleccionados = $event"
                                        v-on:elementoSeleccionado="evtSeleccionNotificador"></CTablaGenericaCedulas>
                                    <div v-if="cargandoNotificadores" class="contenedor-cargando" style="height: 300px ;">
                                        <div class="text-center">
                                            <i class="fas fa-spinner fa-spin fa-5x"></i>
                                            <h4 class="mt-4">Cargando notificadores</h4>
                                        </div>
                                    </div>
                                    <div v-if="listaDeNotificadores.length < 1" class="contenedor-cargando" style="height: 300px ;">
                                        <div class="text-center">
                                            <i class="fas fa-user-slash" style="font-size: 9em;"></i>
                                            <h6 style="margin-top:2em;">No hay notificadores registrados</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="mostrarFormulario" class="mt-4 col-12 pl-0 pr-0">
                        <div class="contenedor-color-negro d-flex">
                            <div class="contenedor-ver-direccionCompleta col-3">
                                <h5>Paso 2: Traza el polígono</h5>
                                <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;" />
                                <div class="d-flex align-items-center">
                                    <h6 style="margin-right: 1em;">Color De Zona: </h6>
                                    <input id="inputColorZona" type=color v-model="colorZona" @change="asignarColorZona">
                                </div>
                                <hr />
                                <button type="button" v-if="!agregar_marcador" @click="eventoAgregarMarcadores" class="btn-xs btn-primary mt-2"><i class="fas fa-map-marker-alt"></i>&nbsp;&nbsp;Agregar Marcadores</button>
                                <button type="button" v-if="agregar_marcador" @click="eventoModoVisualizacion" class="btn-xs btn-primary mt-2"><i class="fas fa-map-marked-alt"></i>&nbsp;&nbsp;Modo visualización</button>
                                <button type="button" @click="eliminarMarcador" class="btn-xs btn-primary mt-2"><i class="fas fa-minus-circle"></i>&nbsp;&nbsp;Eliminar ultimo marcador</button>
                                <button type="button" v-if="marcadores.length >= 3" @click="guardarNuevoPolygonZona" class="btn-xs btn-primary mt-2"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                            </div>
                            <div class="col-9">
                                <div id="contenedor-mapa">
                                    <CMapaDePoligonos
                                    :idMapa="MAPA_FORMULARIO"
                                    :posicionOrigenMapa="posicionOrigenMapa"
                                    :acercamientoInicialMapa="acercamientoInicialMapa"
                                    :colorZona="colorZona"
                                    :polygonoEditar="MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR"
                                    :cargandoMapa="false"
                                    :ref="REF_MAPA_FORMULARIO"
                                    v-on:agregarMarcador="agregar_marcador = $event"
                                    v-on:obtenerMarcadores="marcadores = $event"
                                    v-on:obtenerCoordenadasPolygono="coordenadasPolygono = $event"
                                    v-on:obtenerPoligonos="Polygonos = $event"></CMapaDePoligonos>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- NUEVO LAYOUT -->
        <div id="encabezados-tp">
            <h1>ZONAS</h1>
            <h3>Traza y asigna la cobertura para las notificaciones</h3>
            <div class="hr-titulo"></div>
        </div>
        <!-- SECCION CONSULTA ZONAS REGISTRADAS -->
        <div class="card"  style="margin-top: 3em;">
            <div class="card-header">
                <div class="d-flex align-items-center justify-content-between">
                    <h5><strong>{{ mostrarFormulario ? 'Formulario de zona' : 'Zonas registradas' }}</strong></h5>
                    <button v-if="mostrarFormulario" type="button" @click="eventoCerrarFormulario" class="btn-sm btn-danger"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button>
                    <i @click="expandirMapa" v-if="!mostrarFormulario" v-tooltip:left="'Expandir mapa de zonas'" class="fas fa-expand opcion-expandir-mapa"></i>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <!-- SECCION ZONAS REGISTRADAS -->
                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2">
                        <div>
                            <div v-if="!mostrarFormulario">
                                <div class="text-right">
                                    <div>
                                        <button type="button" @click="agregarZona" class="btn-sm btn-primary"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar</button>
                                    </div> 
                                </div>
                                <CTablaGenericaCedulas v-if="Zonas.length > 0" style="margin-top: 3px;" class="table-responsive"
                                    :idDelInput="ID_TABLA_ZONAS"
                                    :encabezadosColumnas="encabezadosColumnasZonas"
                                    :accionesEnTabla="TABLA_ZONAS_ACCIONES"
                                    :listaDeCedulas="Zonas"
                                    v-on:accionFuncionEliminar="eventoEliminarZona($event)"
                                    v-on:accionesFuncionDeEditar="eventoEditarZona($event)"></CTablaGenericaCedulas>
                                <div v-if="Zonas.length < 1 && !cargandoZonas" class="contenedor-zonas-vacias" >
                                    <div class="text-center">
                                        <i class="fas fa-map-marked-alt mb-4" style="font-size: 9em;"></i>
                                        <h6>No existen zonas agregadas</h6>
                                    </div>
                                </div>
                                <div v-if="cargandoZonas" class="contenedor-cargando mt-2" style="height: 300px ;">
                                    <div class="text-center">
                                        <i class="fas fa-spinner fa-spin fa-5x"></i>
                                        <h4 class="mt-4">Cargando zonas</h4>
                                    </div>
                                </div>
                            </div>
                            <div v-if="mostrarFormulario">
                                <div class="alert alert-secondary" role="alert">
                                    <h4 class="alert-heading"><strong>Guardar zona</strong></h4>
                                    <p>Sigue las instrucciones para guardar una nueva zona o modificar una zona registrada previamente.</p>
                                    <hr>
                                    <p>
                                        <strong>Paso 1</strong><br>
                                        <strong>[1].-</strong> Ingresa un nombre para la zona (no se permiten cadenas de texto vacias).<br>
                                        <strong>[2].-(opcional)</strong> marcar al notificador en el listado (dando click en la casilla de la ultima columna), se puede marcar uno o mas notificadores.
                                    </p>
                                    <p>
                                        <strong>Paso 2</strong><br>
                                        <strong>[1].-</strong> Seleccionar el color del poligono de la zona (dando click en el cuador que se muestra del lado derecho)<br>
                                        <strong>[2].-</strong> Dar click en la opcion <strong>Agregar marcador</strong>.<br>
                                        <strong>[3].-</strong> Navegar dentro del mapa que se muestra del lado derecho dando click en el para agregar un marcador y trazar el poligono de la zona<br>
                                        <strong>[4].-</strong> Para finalizar el proceso y guardar la informacion de la zona se debera dar click en la opcion <strong>Agregar</strong>(sera visible cuando esten al menos tres marcadores ingresados en el mapa)<br>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- SECCION MAPA CONSULTA -->
                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
                        <div class="">
                            <div v-show="!mostrarFormulario && !mapaExpandido.activo">
                                <div class="form-group" style="margin-bottom: 0.5em !important;">
                                    <h6 style="margin-bottom: 0px;">
                                        <strong>[ Ingresa la direccion ]</strong>
                                    </h6>
                                    <i>para una ubicacion mas exacta sigue la siguiente estructura (calle #, fraccionamiento, código postal, municipio)</i>
                                    <div class="d-flex align-items-center">
                                        <input type="text" v-model="busquedaEnMapa.direccion" placeholder="Calle #calle, fraccionamiento, código postal, municipio" class="form-control mr-2"/>
                                        <button type="button" class="btn-sm btn-primary" @click="buscarDireccionEnMapa({ referenciaMapa: REF_MAPA_ZONAS, direccion: busquedaEnMapa.direccion })"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                                    </div>
                                </div>
                                <div id="contenedor-mapa">
                                    <CMapaDePoligonos
                                        :idMapa="MAPA_ZONAS"
                                        :posicionOrigenMapa="posicionOrigenMapa"
                                        :cargandoMapa="cargandoZonas"
                                        :acercamientoInicialMapa="acercamientoInicialMapa"
                                        :colorZona="colorZona"
                                        :polygonoEditar="MAPA_ZONAS_POLIGONO_EDITAR"
                                        :ref="REF_MAPA_ZONAS"
                                        :key="'MAPA-INICIO-' + mapaInicio.contRender"
                                        ></CMapaDePoligonos>
                                </div>
                            </div>
                            <div v-if="!mostrarFormulario && mapaExpandido.activo"
                                 class="contenedor-color-negro d-flex align-items-center justify-content-center" 
                                 style="height: 300px">
                                <i class="far fa-window-restore" style="font-size: 10em;"></i>
                            </div>
                            <div v-show="mostrarFormulario">
                                <div class="contenedor-color-negro">
                                    <div v-if="mostrarFormulario && !cargandoZonas">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h5><strong>Paso 1: Nombre y asignaciones</strong></h5>
                                            <!-- <button @click="eventoCerrarFormulario" id="btn-cerrar-formulario-alta-zona" class="close"><i class="fas fa-times-circle " style="font-size: 25px;"></i></button> -->
                                        </div>
                                        <hr style="height:2px;border:none;color:#FFF;background-color:#FFF; margin-top:6px;" />
                                        <h6><strong>[1]</strong>&nbsp;Nombre de la zona (*)&nbsp;
                                            <i v-if="informarCamposVacios && this.campoRequeridoEsValido(nombreZona)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                            <i v-if="informarCamposVacios && !this.campoRequeridoEsValido(nombreZona)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                                        </h6>
                                        <input v-model="nombreZona" type="text" id="nombre-zona" :class="[(informarCamposVacios && !this.validacionAltaDeZona()) ? 'form-control border border-danger' : 'form-control']" placeholder="Ingrese nombre de la zona" />
                                        <br/>
                                        <br/>
                                        <h6><strong>[2]</strong>&nbsp;Seleccione los notificadores (opcional)</h6>
                                        <CTablaGenericaCedulas v-if="listaDeNotificadores.length > 0 && !cargandoNotificadores" style="margin-top: 3px;" class="table-responsive"
                                            :idDelInput="ID_TABLA_NOTIFICADORES"
                                            :ref="REF_TABLA_NOTIFICADORES"
                                            :encabezadosColumnas="encabezadosColumnasNotificadores"
                                            :accionesEnTabla="TABLA_NOTIFICADORES_ACCIONES"
                                            :listaDeCedulas="listaDeNotificadores"
                                            :listaCedulasSeleccionadas="listaCedulasSeleccionadasEdicion"
                                            v-on:elementosSeleccionados="notificadoresSeleccionados = $event"
                                            v-on:elementoSeleccionado="evtSeleccionNotificador"></CTablaGenericaCedulas>
                                        <div v-if="cargandoNotificadores" class="contenedor-cargando" style="height: 300px ;">
                                            <div class="text-center">
                                                <i class="fas fa-spinner fa-spin fa-5x"></i>
                                                <h4 class="mt-4">Cargando notificadores</h4>
                                            </div>
                                        </div>
                                        <div v-if="listaDeNotificadores.length < 1" class="contenedor-cargando" style="height: 300px ;">
                                            <div class="text-center">
                                                <i class="fas fa-user-slash" style="font-size: 9em;"></i>
                                                <h6 style="margin-top:2em;">No hay notificadores registrados</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- SECCION FORMULARIO TRAZADO DE POLIGONO -->
                    <div v-if="mostrarFormulario" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pt-4">
                        <div class="contenedor-color-negro row no-gutters">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pb-2">
                                <div class="form-inline justify-content-between  align-items-center">
                                    <h5><strong>Paso 2: Traza el polígono</strong></h5>
                                    <i @click="expandirMapaDeFormulario(false)" v-if="mostrarFormulario" v-tooltip:left="'Expandir mapa de zonas'" class="fas fa-expand opcion-expandir-mapa"></i>
                                </div>
                                <hr style="height:2px;border:none;color:#FFF;background-color:#FFF; margin-top:6px;" />
                            </div>
                            <!-- <div class="contenedor-ver-direccionCompleta col-xs-3 col-sm-3 col-md-3 col-lg-3">
                                <div class="d-flex align-items-center">
                                    <h6 style="margin-right: 1em;">Color De Zona: </h6>
                                    <input id="inputColorZona" type=color v-model="colorZona" @change="asignarColorZona">
                                </div>
                                <br />
                                <button type="button" v-if="!agregar_marcador" @click="eventoAgregarMarcadores" class="btn-xs btn-primary mt-2"><i class="fas fa-map-marker-alt"></i>&nbsp;&nbsp;Agregar Marcadores</button>
                                <button type="button" v-if="agregar_marcador" @click="eventoModoVisualizacion" class="btn-xs btn-primary mt-2"><i class="fas fa-map-marked-alt"></i>&nbsp;&nbsp;Modo visualización</button>
                                <button type="button" @click="eliminarMarcador" class="btn-xs btn-primary mt-2"><i class="fas fa-minus-circle"></i>&nbsp;&nbsp;Eliminar ultimo marcador</button>
                                <button type="button" v-if="marcadores.length >= 3" @click="guardarNuevoPolygonZona" class="btn-xs btn-primary mt-2"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                            </div> -->
                            <div class="contenedor-ver-direccionCompleta row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-1 pb-3">
                                    <div class="d-flex align-items-center">
                                        <h6 style="margin-right: 1em;">Color De Zona: </h6>
                                        <input id="inputColorZona" type=color v-model="colorZona" @change="asignarColorZona({ referenciaMapa: REF_MAPA_FORMULARIO })">
                                    </div>
                                </div>
                                <div v-if="!agregar_marcador" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-1 pt-1">
                                    <div class="d-flex align-items-center">
                                        <button type="button" @click="eventoAgregarMarcadores({ referenciaMapa: REF_MAPA_FORMULARIO })" class="btn-xs btn-primary"><i class="fas fa-map-marker-alt"></i>&nbsp;&nbsp;Agregar Marcadores</button>
                                    </div>
                                </div>
                                <div v-if="agregar_marcador" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-1 pt-1">
                                    <div class="d-flex align-items-center">
                                        <button type="button" @click="eventoModoVisualizacion({ referenciaMapa: REF_MAPA_FORMULARIO })" class="btn-xs btn-primary"><i class="fas fa-map-marked-alt"></i>&nbsp;&nbsp;Modo visualización</button>
                                    </div>
                                </div>
                                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-1 pt-1">
                                    <div class="d-flex align-items-center">
                                        <button type="button" @click="eliminarMarcador({ referenciaMapa: REF_MAPA_FORMULARIO })" class="btn-xs btn-primary"><i class="fas fa-minus-circle"></i>&nbsp;&nbsp;Eliminar ultimo marcador</button>
                                    </div>
                                </div>
                                <div v-if="marcadores.length >= 3" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-1 pt-1">
                                    <div class="d-flex align-items-center">
                                        <button type="button"  @click="guardarNuevoPolygonZona({ referenciaMapa: REF_MAPA_FORMULARIO })" class="btn-xs btn-primary"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-0 pt-4">
                                <div class="form-group" style="margin-bottom: 0.5em !important;">
                                    <h6 style="margin-bottom: 0px;">
                                        <strong>[ Ingresa la direccion ]</strong>
                                    </h6>
                                    <i>para una ubicacion mas exacta sigue la siguiente estructura (calle #, fraccionamiento, código postal, municipio)</i>
                                    <div class="d-flex align-items-center">
                                        <input type="text" v-model="mapaExpandidoFormulario.direccion" placeholder="Calle #calle, fraccionamiento, código postal, municipio" class="form-control mr-2"/>
                                        <button type="button" class="btn-sm btn-primary" @click="buscarDireccionEnMapaFormulario({ referenciaMapa: REF_MAPA_FORMULARIO, direccion: mapaExpandidoFormulario.direccion })"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                                    </div>
                                </div>
                                <div id="contenedor-mapa">
                                    <CMapaDePoligonos
                                    :idMapa="MAPA_FORMULARIO"
                                    :posicionOrigenMapa="posicionOrigenMapa"
                                    :acercamientoInicialMapa="acercamientoInicialMapa"
                                    :colorZona="colorZona"
                                    :polygonoEditar="MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR"
                                    :cargandoMapa="false"
                                    :ref="REF_MAPA_FORMULARIO"
                                    v-on:agregarMarcador="agregar_marcador = $event"
                                    v-on:obtenerMarcadores="marcadores = $event"
                                    v-on:getCoordenadasBusquedaDireccion="evtAgregarMarcadorMetodoBusqueda"
                                    v-on:obtenerCoordenadasPolygono="coordenadasPolygono = $event"
                                    v-on:obtenerPoligonos="Polygonos = $event"
                                    :key="'KEY-Mapa-Formulario-VADZ' + contRenderMapaFormulario"></CMapaDePoligonos>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- MAPA EXPANDIDO MODAL -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-mapa-expandido">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Mapa de zonas</h5>
                        <button class="close" @click="mapaExpandido.activo = false, mapaExpandido.direccion = null" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-0 pr-0 pb-0">
                        <div>
                            <div class="d-flex">
                                <div class="form-group pr-4 pl-4" style="margin-bottom: 0.5em !important; width: 800px !important;">
                                    <h6 style="margin-bottom: 0px;">
                                        <strong>[ Ingresa la direccion ]</strong>
                                    </h6>
                                    <i>para una ubicacion mas exacta sigue la siguiente estructura (calle #, fraccionamiento, código postal, municipio)</i>
                                    <div class="d-flex align-items-center">
                                        <input type="text" v-model="mapaExpandido.direccion" placeholder="Calle #calle, fraccionamiento, código postal, municipio" class="form-control mr-2"/>
                                        <button type="button" class="btn-sm btn-primary" @click="buscarDireccionEnMapa({ referenciaMapa: mapaExpandido.REF, direccion: mapaExpandido.direccion })"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                                    </div>
                                </div>
                            </div>
                            <div id="contenedor-mapa-expandido">
                                <CMapaDePoligonos
                                    :idMapa="mapaExpandido.ID"
                                    :posicionOrigenMapa="posicionOrigenMapa"
                                    :cargandoMapa="mapaExpandido.cargando"
                                    :acercamientoInicialMapa="acercamientoInicialMapa"
                                    :colorZona="colorZona"
                                    :polygonoEditar="MAPA_ZONAS_POLIGONO_EDITAR"
                                    :ref="mapaExpandido.REF"
                                    :key="mapaExpandido.KEY + mapaExpandido.contRender"
                                    ></CMapaDePoligonos>
                            </div>
                        </div>
                    </div>           
                </div>
            </div>
        </div>
        <!-- MODAL CONFIRMACION AGREGAR MARCADOR -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-confirmar-add-marcador">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Mensaje del sistema</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>Deseas agregar un marcador al poligono de la zona con la direccion ingresada</h6>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="evtAgregarMarcadorPorDireccion({ agregar: true })"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="evtAgregarMarcadorPorDireccion({ agregar: false })"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MAPA EXPANDIDO MODAL -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-mapa-expandido-formulario">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Paso 2: Traza el polígono</h5>
                        <button class="close" @click="evtCerrarModalPasoDos" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-0 pr-0">
                        <div class="row no-gutters pr-4 pl-4">
                            <div class="contenedor-ver-direccionCompleta row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-1 pb-3">
                                    <div class="d-flex align-items-center">
                                        <h6 style="margin-right: 1em;">Color De Zona: </h6>
                                        <input id="inputColorZona" type=color v-model="colorZona" @change="asignarColorZona({ referenciaMapa: mapaExpandidoFormulario.REF })">
                                    </div>
                                </div>
                                <div v-if="!agregar_marcador" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-1 pt-1">
                                    <div class="d-flex align-items-center">
                                        <button type="button" @click="eventoAgregarMarcadores({ referenciaMapa: mapaExpandidoFormulario.REF })" class="btn-xs btn-primary"><i class="fas fa-map-marker-alt"></i>&nbsp;&nbsp;Agregar Marcadores</button>
                                    </div>
                                </div>
                                <div v-if="agregar_marcador" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-1 pt-1">
                                    <div class="d-flex align-items-center">
                                        <button type="button" @click="eventoModoVisualizacion({ referenciaMapa: mapaExpandidoFormulario.REF })" class="btn-xs btn-primary"><i class="fas fa-map-marked-alt"></i>&nbsp;&nbsp;Modo visualización</button>
                                    </div>
                                </div>
                                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-1 pt-1">
                                    <div class="d-flex align-items-center">
                                        <button type="button" @click="eliminarMarcador({ referenciaMapa: mapaExpandidoFormulario.REF })" class="btn-xs btn-primary"><i class="fas fa-minus-circle"></i>&nbsp;&nbsp;Eliminar ultimo marcador</button>
                                    </div>
                                </div>
                                <div v-if="marcadores.length >= 3" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-1 pt-1">
                                    <div class="d-flex align-items-center">
                                        <button type="button"  @click="guardarNuevoPolygonZona({ referenciaMapa: mapaExpandidoFormulario.REF })" class="btn-xs btn-primary"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-0 pt-4">
                                <div class="form-group" style="margin-bottom: 0.5em !important; width: 800px !important;">
                                    <h6 style="margin-bottom: 0px;">
                                        <strong>[ Ingresa la direccion ]</strong>
                                    </h6>
                                    <i>para una ubicacion mas exacta sigue la siguiente estructura (calle #, fraccionamiento, código postal, municipio)</i>
                                    <div class="d-flex align-items-center">
                                        <input type="text" v-model="mapaExpandidoFormulario.direccion" placeholder="Calle #calle, fraccionamiento, código postal, municipio" class="form-control mr-2"/>
                                        <button type="button" class="btn-sm btn-primary" @click="buscarDireccionEnMapaFormulario({ referenciaMapa: mapaExpandidoFormulario.REF, direccion: mapaExpandidoFormulario.direccion })"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                                    </div>
                                </div>
                                <!-- <div id="contenedor-mapa-expandido-formulario">
                                    <CMapaDePoligonos
                                    :idMapa="mapaExpandidoFormulario.ID"
                                    :posicionOrigenMapa="posicionOrigenMapa"
                                    :acercamientoInicialMapa="acercamientoInicialMapa"
                                    :colorZona="colorZona"
                                    :polygonoEditar="MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR"
                                    :cargandoMapa="false"
                                    :ref="mapaExpandidoFormulario.REF"
                                    v-on:agregarMarcador="agregar_marcador = $event"
                                    v-on:obtenerMarcadores="marcadores = $event"
                                    v-on:getCoordenadasBusquedaDireccion="evtAgregarMarcadorMetodoBusquedaMapaExpandido"
                                    v-on:obtenerCoordenadasPolygono="coordenadasPolygono = $event"
                                    v-on:obtenerPoligonos="Polygonos = $event"
                                    :key="mapaExpandidoFormulario.KEY + mapaExpandidoFormulario.contRender"></CMapaDePoligonos>
                                </div> -->
                            </div>
                        </div>
                        <div class="row no-gutters pr-0 pl-0">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-0 pl-0 pt-0">
                                <div id="contenedor-mapa-expandido-formulario">
                                    <CMapaDePoligonos
                                    :idMapa="mapaExpandidoFormulario.ID"
                                    :posicionOrigenMapa="posicionOrigenMapa"
                                    :acercamientoInicialMapa="acercamientoInicialMapa"
                                    :colorZona="colorZona"
                                    :polygonoEditar="MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR"
                                    :cargandoMapa="false"
                                    :ref="mapaExpandidoFormulario.REF"
                                    v-on:agregarMarcador="agregar_marcador = $event"
                                    v-on:obtenerMarcadores="marcadores = $event"
                                    v-on:getCoordenadasBusquedaDireccion="evtAgregarMarcadorMetodoBusquedaMapaExpandido"
                                    v-on:obtenerCoordenadasPolygono="coordenadasPolygono = $event"
                                    v-on:obtenerPoligonos="Polygonos = $event"
                                    :key="mapaExpandidoFormulario.KEY + mapaExpandidoFormulario.contRender"></CMapaDePoligonos>
                                </div>
                            </div>
                        </div>
                    </div>           
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'

export default {
  directives: {
    tooltipF
  },
  components: {
    CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas,
    CMapaDePoligonos: sistemas.SINOJ.CMapaDePoligonos
  },
  data() {
    return {
        posicionOrigenMapa: [21.878305650330997,-102.29601653410975],
        acercamientoInicialMapa: 13.4,
        ID_TABLA_ZONAS: 'tablaDeZonasPrincipal',
        encabezadosColumnasZonas: ['Folio','Nombre','Color',''],
        TABLA_ZONAS_ACCIONES: {motrarAcciones: true,check: false, eliminar: true, editar:true, detalles:false},
        /* listaDeZonas: [
            {Folio:1,Nombre: 'Zona1',Color: '<i class="fas fa-square-full" style="color: #2d6b29; font-size: 20px;"></i>'},
            {Folio:2,Nombre: 'Zona2',Color: '<i class="fas fa-square-full" style="color: #2d6b29; font-size: 20px;"></i>'},
            {Folio:3,Nombre: 'Zona3',Color: '<i class="fas fa-square-full" style="color: #2d6b29; font-size: 20px;"></i>'},
            {Folio:4,Nombre: 'Zona4',Color: '<i class="fas fa-square-full" style="color: #2d6b29; font-size: 20px;"></i>'},
            {Folio:5,Nombre: 'Zona5',Color: '<i class="fas fa-square-full" style="color: #2d6b29; font-size: 20px;"></i>'},
            {Folio:6,Nombre: 'Zona6',Color: '<i class="fas fa-square-full" style="color: #2d6b29; font-size: 20px;"></i>'}
        ], */
        ID_TABLA_NOTIFICADORES: 'tablaDeNotificadoresZonas',
        REF_TABLA_NOTIFICADORES: 'RefTablaNotificadoresVADZ',
        encabezadosColumnasNotificadores: ['id','Nombre','Apellido paterno','Apellido materno',''],
        TABLA_NOTIFICADORES_ACCIONES: {motrarAcciones: true,check: true, eliminar: false, editar:false, detalles:false},
        listaDeNotificadores: [
            /* {Nombre:'Nombre 1', ApellidoPaterno: 'apellido paterno 1', ApellidoMaterno: 'apellido materno 1'},
            {Nombre:'Nombre 2', ApellidoPaterno: 'apellido paterno 2', ApellidoMaterno: 'apellido materno 2'},
            {Nombre:'Nombre 3', ApellidoPaterno: 'apellido paterno 3', ApellidoMaterno: 'apellido materno 3'},
            {Nombre:'Nombre 4', ApellidoPaterno: 'apellido paterno 4', ApellidoMaterno: 'apellido materno 4'},
            {Nombre:'Nombre 5', ApellidoPaterno: 'apellido paterno 5', ApellidoMaterno: 'apellido materno 5'}, */
        ],
        listaDeNotificadoresBD: [],
        nombreZona: null,
        mostrarFormulario: false,
        marcadores: [],
        coordenadasPolygono: [],
        Polygonos: [],
        MAPA_ZONAS_POLIGONO_EDITAR: [],
        MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR: [],
        MAPA_ZONAS: "idMapaZonasAdministracion",
        MAPA_FORMULARIO: "idMapaFormulario",
        REF_MAPA_FORMULARIO: 'RefMapaFormulario',
        REF_MAPA_ZONAS: 'RefMapaZonas',
        motrarMapaHerramientas: true,
        agregar_marcador: false,
        colorZona: "#00000",
        zonas: [],
        zonasCamposCompletos: [],
        informarCamposVacios: false,
        notificadoresSeleccionados: [],
        cargandoNotificadores: false,
        cargandoZonas: true,
        zonaEnEdicion: false,
        listaCedulasSeleccionadasEdicion: [],
        zonaSelccionadaEdicion: null,
        agregandoZona: false,
        cargoAreaDeUsuario: false,
        mapaInicio: {
            contRender: 0
        },
        busquedaEnMapa: {
            direccion: null
        },
        mapaExpandido: {
            ID: 'ID_mapaConsultaZonas',
            cargando: false,
            KEY: 'KEY_mapaConsultaZonas',
            REF: 'REF_mapaConsultaZonas',
            contRender: 0,
            activo: false,
            direccion: null
        },
        mapaExpandidoFormulario: {
            ID: 'ID_mapaFormularioZonas',
            cargando: false,
            KEY: 'ID_mapaFormularioZonas',
            REF: 'ID_mapaFormularioZonas',
            contRender: 0,
            activo: false,
            direccion: null
        },
        polygonosDeZonasDB: [],
        coordMarcadorDeBusqueda: [],
        poligonosDeFormularioTmp: [],
        contRenderMapaFormulario: 0,
        mapaDeFormularioExpandido: false
    }
  },
  methods: {
      evtCerrarModalPasoDos: function() {
          $("#modal-mapa-expandido-formulario").modal('hide');
          this.agregar_marcador = false;
          this.mapaDeFormularioExpandido = false;
          this.MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR[0].color = this.$refs[this.mapaExpandidoFormulario.REF].colorZona;
          this.MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR[0].coordenadas = this.coordenadasPolygono;
          this.$nextTick(() => {
            this.contRenderMapaFormulario ++;
          }); 
      },
      expandirMapaDeFormulario: function(conActaulizacionDePosicion = false) { 
            // se ocultan la directiva tooltip
            $(".tooltip").tooltip("hide");
            this.$nextTick(() => { 
                $(".tooltip").tooltip("hide");
            }); 
            this.agregar_marcador = false;
            this.mapaDeFormularioExpandido = true;
            if(this.campoRequeridoEsValido(this.MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR)) {
                this.MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR[0].color = this.$refs[this.REF_MAPA_FORMULARIO].colorZona;
                this.MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR[0].coordenadas = this.coordenadasPolygono;
            }
            else {
                let poligonoObj = { color: this.$refs[this.REF_MAPA_FORMULARIO].colorZona, coordenadas: this.coordenadasPolygono }
                this.MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR.push(poligonoObj);
            }
            $("#modal-mapa-expandido-formulario").modal('show');
            this.mapaExpandidoFormulario.contRender ++;
            /* this.$nextTick(() => {
                this.mapaExpandidoFormulario.contRender ++;
            }); */
            if(conActaulizacionDePosicion) {
                this.actualizarPosicionMapaFormulario();
            }
      },
      actualizarPosicionMapaFormulario: function() {
            this.$nextTick(() => {
                console.log('coordOrigen::',this.coordMarcadorDeBusqueda);
                this.$refs[this.mapaExpandidoFormulario.REF].actualizarMapa({ posicion: this.coordMarcadorDeBusqueda });
            });
      },
      evtAgregarMarcadorPorDireccion: function({ agregar }) {
          let referencia = (this.mapaDeFormularioExpandido) ? this.mapaExpandidoFormulario.REF : this.REF_MAPA_FORMULARIO;
          $("#modal-confirmar-add-marcador").modal('hide');
          if(agregar) {
              if(this.campoRequeridoEsValido(this.coordMarcadorDeBusqueda)) {
                this.$nextTick(() => {
                    let objCoordenada = { lat: this.coordMarcadorDeBusqueda[0], lng: this.coordMarcadorDeBusqueda[1] };
                    this.$refs[referencia].agregarMarcador(objCoordenada);
                });
            }
          }
          if(this.mapaDeFormularioExpandido) {
              this.$nextTick(() => {
                  this.expandirMapaDeFormulario(true);
              });
          }
      },
      evtAgregarMarcadorMetodoBusqueda: function(coordenadas) { 
          const LATITUD_INDEX  = 0;
          const LONGITUD_INDEX = 1;
          let agregarMarcadorPorDireccionConfirmar = 
            !(coordenadas[LATITUD_INDEX] == this.coordMarcadorDeBusqueda[LATITUD_INDEX] && coordenadas[LONGITUD_INDEX] == this.coordMarcadorDeBusqueda[LONGITUD_INDEX]);

          this.coordMarcadorDeBusqueda = coordenadas;
          if(agregarMarcadorPorDireccionConfirmar)
            $("#modal-confirmar-add-marcador").modal('show');
      },
      evtAgregarMarcadorMetodoBusquedaMapaExpandido: function(coordenadas) { 
          const LATITUD_INDEX  = 0;
          const LONGITUD_INDEX = 1;
          console.log(this.coordMarcadorDeBusqueda)
          console.log(coordenadas)
          let agregarMarcadorPorDireccionConfirmar = 
            !(coordenadas[LATITUD_INDEX] == this.coordMarcadorDeBusqueda[LATITUD_INDEX] && coordenadas[LONGITUD_INDEX] == this.coordMarcadorDeBusqueda[LONGITUD_INDEX]);

          this.coordMarcadorDeBusqueda = coordenadas;
          if(agregarMarcadorPorDireccionConfirmar) {
              $("#modal-mapa-expandido-formulario").modal('hide');
                this.agregar_marcador = false;
                this.MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR[0].color = this.$refs[this.mapaExpandidoFormulario.REF].colorZona;
                this.MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR[0].coordenadas = this.coordenadasPolygono;
                this.$nextTick(() => {
                    this.contRenderMapaFormulario ++;
                }); 
              $("#modal-confirmar-add-marcador").modal('show');
          }
      },
      expandirMapa: function() {
        this.mapaExpandido.activo = true;
        // se ocultan la directiva tooltip
        $(".tooltip").tooltip("hide");
        this.$nextTick(() => { 
            $(".tooltip").tooltip("hide");
        });

        $("#modal-mapa-expandido").modal('show');
        this.$nextTick(() => {
            this.mapaExpandido.contRender ++;
            this.cargarPoligonosMapaExpandido();
        });
      },
      cargarPoligonosMapaExpandido: async function() {
          this.$nextTick(() => {
              const { REF } = this.mapaExpandido;
              this.$refs[REF].mostrarPoligonosAgregados(this.polygonosDeZonasDB);
          });
      },
      buscarDireccionEnMapa: function({ referenciaMapa, direccion }) { 
          if(!this.mostrarFormulario && this.campoRequeridoEsValido(direccion)) {
            this.$nextTick(() => {
                let calle = `${ direccion }, Aguascalientes MX`;
                this.$refs[referenciaMapa].obtenerCoordenadasPorCalleCompleta({ calleCompleta: calle });
            });
          }
          else {
              comun.mensajeDeAlerta('Debes ingresar una direccion valida');
          }
      },
      buscarDireccionEnMapaFormulario: function({ referenciaMapa, direccion }) { 
          if(this.campoRequeridoEsValido(direccion)) {
            this.$nextTick(() => {
                let calle = `${ direccion }, Aguascalientes MX`;
                this.$refs[referenciaMapa].obtenerCoordenadasPorCalleCompleta({ calleCompleta: calle, conMarcador: false });
            });
          }
          else {
              comun.mensajeDeAlerta('Debes ingresar una direccion valida');
          }
      },
      evtSeleccionNotificador: function(evento) {
          //console.log('evtSeleccionNotificador::',evento);
          const NOTIFICADOR_ID = evento.folio;
          const NOTIFICADOR_SELECCIONADO = evento.enviar;
          const INPUT_CHECK = evento.idCheck;
          if(NOTIFICADOR_SELECCIONADO) {
              const INDEX_NOTIFICADOR = this.listaDeNotificadoresBD.findIndex(n => n.NotificadorId == NOTIFICADOR_ID);
              if(INDEX_NOTIFICADOR != null && INDEX_NOTIFICADOR != undefined && INDEX_NOTIFICADOR >= 0) {
                  const NOTIFICADOR_BD = this.listaDeNotificadoresBD[INDEX_NOTIFICADOR];
                  if(NOTIFICADOR_BD.Zona != null) {
                      if(this.zonaEnEdicion && this.zonaSelccionadaEdicion.Nombre != NOTIFICADOR_BD.Zona.Nombre) 
                          this.confirmacionCambioZonaANotificador(NOTIFICADOR_BD,INPUT_CHECK);
                      else if(!this.zonaEnEdicion)
                          this.confirmacionCambioZonaANotificador(NOTIFICADOR_BD,INPUT_CHECK);
                  } // valida que el notificador ya tenga una zona asignada
              } // valida que la busqueda del notificador tenga un index valido
          } // valida si el notificador esta seleccionado check = isChecked
      },
      agregarZona: async function() {
          this.mostrarFormulario = true;
          this.agregandoZona = true;
         /*  let zonaNueva = {
              Folio:(this.contTmp + 1),Nombre: 'Zona1'
          }
          this.listaDeZonas.push(zonaNueva);
          this.contTmp = zonaNueva.Folio; */
          this.cargandoNotificadores = true;
          await this.cargarNotificadoresRegistradasBD();
          this.motrarMapaHerramientas = true;
      },
      eventoCerrarFormulario: function() {
          this.$refs.RefMapaFormulario.limpiarVariablesPolygonos();
          this.mostrarFormulario = false;
          this.$refs.RefMapaZonas.mostrarPoligonosAgregados(this.Polygonos);
          this.cargarZonasRegistradas();
          this.informarCamposVacios = false;
          this.limpiarVariablesZonaFormulario();
          this.cargandoNotificadores = false;
          this.busquedaEnMapa.direccion = null;
      },
      eventoEliminarZona: async function(evento) { debugger
          //console.log('eliminarZona::',evento);
          if(!this.zonaEnEdicion && !this.agregandoZona) {
              const zona = await Promise.resolve(this.obtenerZonaSeleccionada(evento));
              this.confirmarEliminarZona(zona);
          }
          else {
              switch(true){
                  case this.agregandoZona:
                      comun.mensajeDeAlerta('Actualmente se encuentra agregando una zona, para eliminar la zona debes cerrar el formulario.', null, null);
                      break;
                  case this.zonaEnEdicion:
                      comun.mensajeDeAlerta('Actualmente se encuentra editando una zona, para eliminar la zona debes cerrar el formulario.', null, null);
                      break;
                  default:
                      break;
              }
          }
      },
      eventoEditarZona: async function(evento) { 
          if(!this.zonaEnEdicion && !this.agregandoZona) {
                this.cargandoNotificadores = true;
                this.cargarNotificadoresRegistradasBD();
                this.motrarMapaHerramientas = true;
                const ZONA = await Promise.resolve(this.obtenerZonaSeleccionada(evento));
                this.listaCedulasSeleccionadasEdicion = ZONA.Notificadores;
                this.notificadoresSeleccionados = (ZONA.Notificadores != null && ZONA.Notificadores != undefined && ZONA.Notificadores.length > 0)
                    ? ZONA.Notificadores.map(n => ({ ...n, enviar: true, folio: n.NotificadorId })) : [];
                let polygonosObjZona = [];
                this.colorZona = ZONA.Color;
                let polygonoObj = {};
                polygonoObj.color = ZONA.Color;
                let coordenadasPolygonoObj = [];
                if(ZONA.Poligonos != null && ZONA.Poligonos.length > 0) {
                    ZONA.Poligonos.forEach(p => {
                        if(p.Coordenada != null) {
                            let coordenadas = [];
                            coordenadas.push(p.Coordenada.Latitud);
                            coordenadas.push(p.Coordenada.Longitud);
                            coordenadasPolygonoObj.push(coordenadas);
                        }
                    });
                }
                polygonoObj.coordenadas = coordenadasPolygonoObj;
                polygonosObjZona.push(polygonoObj);
                //console.log('eventoEditarZona::',polygonosObjZona);
                this.MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR = polygonosObjZona;
                /* let peticion = this.crearPeticionNuevaZona(); */
                this.nombreZona = ZONA.Nombre;
                this.mostrarFormulario = true;
                /* peticion.Zona = ZONA; */
                this.zonaSelccionadaEdicion = ZONA;
                this.zonaEnEdicion = true;
                if(this.mostrarFormulario && !this.cargandoZonas) {
                    this.$nextTick(() => {
                        //console.log('elemento::',$("#" + this.ID_TABLA_NOTIFICADORES + 'seleccionarTodos'));
                        //this.notificadoresSeleccionados = []; // agregado 07/04/2021
                        $("#" + this.ID_TABLA_NOTIFICADORES + 'seleccionarTodos').hide();
                    });
                }
          }
          else {
              let mensaje = (this.agregandoZona) ? 'Actualmente se encuentra agregando una zona, para editar la zona debes cerrar el formulario.' : 'Actualmente se encuentra editando una zona';
              comun.mensajeDeAlerta(mensaje, null, null);
          }
      },
      editarZonaBD: function(peticionAPI) {
           const SERVIDOR = api.conexion;
            const METODO_API_EDITAR = api.SINOJ.sistema.administracion.zonas.EditarZona;
            let urlApi = SERVIDOR + METODO_API_EDITAR;
            // craeamos la peticion con el formulario 
            //console.log('statusSeccion::' + urlApi);
            //console.log('peticionPI::',peticionAPI);
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("ejecuto bien :: " + respuesta.data);
                            this.$refs.RefMapaFormulario.limpiarVariablesPolygonos();
                            this.mostrarFormulario = false;
                            this.$refs.RefMapaZonas.mostrarPoligonosAgregados(this.Polygonos);
                            this.cargarZonasRegistradas();
                            this.informarCamposVacios = false;
                            this.limpiarVariablesZonaFormulario();
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
      },
      eliminarZonaDB: function(peticionAPI) { debugger
        const SERVIDOR = api.conexion;
        const METODO_API_AGREGAR = api.SINOJ.sistema.administracion.zonas.EliminarZona;
        let urlApi = SERVIDOR + METODO_API_AGREGAR;
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(respuesta.data.Error);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                        //console.log("ejecuto bien :: " + respuesta.data);
                        this.cargandoZonas = true;
                        this.cargarZonasRegistradas();
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
        ); 
      },
      obtenerZonaSeleccionada: async function(evento) { 
          let zona = null;
          const zonaSeleccionada = evento.target.getAttribute('id');
          const idZona = parseInt(this.obtenerIdZonaTabla(zonaSeleccionada));
          this.zonasCamposCompletos.filter(zc => zc.ZonaId == idZona).forEach(z => {
              zona = z;
          });
          console.log('obtenerZonaSeleccionada:sel::',zona);
          if(zona != null && zona != undefined) {
              zona.Notificadores = await Promise.resolve(this.obtenerNotificadoresDeZonaEdicionDB({ zonaId: zona.ZonaId }));
          }
          return zona;
      },
        obtenerNotificadoresDeZonaEdicionDB: async function({ zonaId }) { 
            let notificadores = [];
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.sistema.administracion.notificadores.ObtenerNotificadores;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI  = {
                    ZonaId: zonaId,
                    Nombre: null,
                    ApellidoPaterno: null,
                    ApellidoMaterno: null,
                    ConInactivos: false,
                };
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Notificadores } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else { 
                    notificadores = Notificadores;
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return notificadores;
        },
      obtenerIdZonaTabla: function(zonaSeleccionada) {
          const zona = zonaSeleccionada.split('-');
          const posicionDeId = (zona.length - 1);
          const idZona = zona[posicionDeId];
          return idZona;
      },
      eventoAgregarMarcadores: function({ referenciaMapa }) { 
          let referencia = (!this.campoRequeridoEsValido(referenciaMapa)) ? this.RefMapaFormulario : referenciaMapa;
          this.$refs[referencia].agregarMarcadores();
      },
      eventoModoVisualizacion: function({ referenciaMapa }) {
          let referencia = (!this.campoRequeridoEsValido(referenciaMapa)) ? this.RefMapaFormulario : referenciaMapa;
          this.$refs[referencia].modoVisualizacion();
      },
      eliminarMarcador: function({ referenciaMapa }) {
          let referencia = (!this.campoRequeridoEsValido(referenciaMapa)) ? this.RefMapaFormulario : referenciaMapa;
          this.$refs[referencia].eliminarMarcador();
      },
      validacionAltaDeZona: function() {
          let formularioEsValido = false;
          // 3 numero minimo de aristas para crear un poligono
          if(this.campoRequeridoEsValido(this.nombreZona)) {
              formularioEsValido = true;
          }
          this.informarCamposVacios = true;
          return formularioEsValido;
      },
      guardarNuevoPolygonZona: function({ referenciaMapa }) { debugger
          if(referenciaMapa == this.mapaExpandidoFormulario.REF) {
              $("#modal-mapa-expandido-formulario").modal('hide');
          }
          if(!this.zonaEnEdicion) {
                if(this.validacionAltaDeZona()) {
                    this.$refs[referenciaMapa].guardarNuevoPolygonZona();
                    //console.log('guardarNuevoPolygonZona::',this.Polygonos);
                    let peticion = this.crearPeticionAltaZona();
                    this.guardarPolygonoDB(peticion);
                }
                else {
                    comun.mensajeDeAlerta('No has ingresa el nombre de la zona', null, null);
                }
          }
          else {
            if(this.validacionAltaDeZona()) {
                let peticion = this.crearPeticionAltaZona();
                peticion.Zona.ZonaId = this.zonaSelccionadaEdicion.ZonaId;
                //console.log('PETICION::',peticion);
                this.editarZonaBD(peticion);
            }
            else {
                comun.mensajeDeAlerta('No has ingresa el nombre de la zona', null, null);
            }
          }
      },
      limpiarVariablesZonaFormulario: function() {
          this.nombreZona = '';
          this.colorZona = '#000000';
          if(this.$refs[this.REF_MAPA_FORMULARIO] != null && this.$refs[this.REF_MAPA_FORMULARIO] != undefined)
            this.eventoModoVisualizacion({ referenciaMapa: this.REF_MAPA_FORMULARIO });

          if(this.$refs[this.mapaExpandidoFormulario.REF] != null && this.$refs[this.mapaExpandidoFormulario.REF] != undefined) 
            this.eventoModoVisualizacion({ referenciaMapa: this.mapaExpandidoFormulario.REF });

          this.marcadores = [];
          this.listaDeNotificadores = [];
          this.listaDeNotificadoresBD = [];
          this.notificadoresSeleccionados = []; // agregado 07/04/2021
          this.MAPA_ZONAS_FORMULARIO_POLIGONO_EDITAR = [];
          this.zonaEnEdicion = false;
          this.agregandoZona = false;
          this.listaCedulasSeleccionadasEdicion = [];
          this.zonaSelccionadaEdicion = null;
          this.poligonosDeFormularioTmp = [];
          this.mapaDeFormularioExpandido = false;
          this.mapaExpandidoFormulario.direccion = null;
          this.coordMarcadorDeBusqueda = [];
      }, 
      guardarPolygonoDB: function(peticionAPI) {
        const SERVIDOR = api.conexion;
        const METODO_API_AGREGAR = api.SINOJ.sistema.administracion.zonas.GuardarNuevaZona;
        let urlApi = SERVIDOR + METODO_API_AGREGAR;
        // craeamos la peticion con el formulario 
        //console.log('statusSeccion::' + urlApi);
        //console.log('peticionPI::',peticionAPI);
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(mensajeError);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                        //console.log("ejecuto bien :: " + respuesta.data);
                        this.$refs.RefMapaFormulario.limpiarVariablesPolygonos();
                        this.mostrarFormulario = false;
                        this.$refs.RefMapaZonas.mostrarPoligonosAgregados(this.Polygonos);
                        this.cargarZonasRegistradas();
                        this.informarCamposVacios = false;
                        this.limpiarVariablesZonaFormulario();
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
        ); 
      },
      crearPeticionAltaZona: function() {
          let peticion = {};
          let zonaObj = {};
          zonaObj.ZonaId = -1;
          zonaObj.Nombre = this.nombreZona;
          zonaObj.Color = this.colorZona;
          let poligonosDeZona = [];
          let notificadoresDeZona = [];
          // se crea el poligono de la zona y se asigna a la coordenada a la que pertenecera.
          if(this.coordenadasPolygono.length > 0) {
              this.coordenadasPolygono.forEach(c => {
                  let coordenadaObj = {
                      CoordenadaId: -1,
                      Poligonos: null,
                      Domicilio: null,
                      Latitud: c[0],
                      Longitud: c[1]
                  }
                  let poligonoObj = {
                      PoligonoId: -1,
                      Coordenada: coordenadaObj,
                      Zona: null,
                  }
                  poligonosDeZona.push(poligonoObj);
              });
          }
          zonaObj.Poligonos = poligonosDeZona;
          this.notificadoresSeleccionados
          .filter(ns => ns.enviar)
          .forEach(n => {
              let notificador = {};
              notificador.NotificadorId = n.folio;
              notificador.Usuario = null;
              notificador.Zona = null;
              notificador.Activo = true;
              notificador.Salidas = null;
              notificador.Cedulas = null;
              notificadoresDeZona.push(notificador);
          });
          zonaObj.Notificadores = notificadoresDeZona;
          peticion.Zona = zonaObj;
          peticion.esPrueba = false;
          return peticion;
      },
      asignarColorZona: function({ referenciaMapa }) {
          this.$refs[referenciaMapa].agregarPolygono();
      },
      lugarSeEncuentraEnPolygono: function(marcador, polygono) {
            let puntoDePolygono = polygono.coordenadas;       
            let x = marcador.lat; 
            let y = marcador.lng;
            //console.log('puntoDePolygono::',puntoDePolygono);
            //console.log('x::' + x);
            //console.log('y::' + y);

            let seEncuentraDentro = false;
            for (let i = 0, j = puntoDePolygono.length - 1; i < puntoDePolygono.length; j = i++) {
                let xi = puntoDePolygono[i].lat, yi = puntoDePolygono[i].lng;
                let xj = puntoDePolygono[j].lat, yj = puntoDePolygono[j].lng;

                let interseccion = ((yi > y) != (yj > y))
                    && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
                if (interseccion) seEncuentraDentro = !seEncuentraDentro;
            }
            return seEncuentraDentro;
      },
      perteneceAlPolygono: function() {
          // con algoritmo Ray Casting
          let coordenada1 = {lat: 21.8923683, lng: -102.381439};
          let coordenada2 = {lat: 21.8811378, lng: -102.391312};
          let coordenada3 = {lat: 21.87628, lng: -102.376289};
          let coordenadasPolygono = [coordenada1,coordenada2,coordenada3];
          let polygono = { coordenadas: coordenadasPolygono};
          let marcador = { lat: 21.8184227, lng: -102.297523};
          let perteneceAPolygono = this.lugarSeEncuentraEnPolygono(marcador,polygono);
          //console.log('pertenece::' + perteneceAPolygono);

        /* con libreria npm i leaflet-pip 
        let m1 = L.marker([21.876672837710647, -102.27846731850076]);  fuera
        let m2 = L.marker([21.868310602815388, -102.27021057829268]);  dentro

        console.log(this.polygonoPrincipal.contains(m1.getLatLng()));
        console.log(this.polygonoPrincipal.contains(m2.getLatLng())); */
      },
      cargarZonasRegistradas: function() {
        const SERVIDOR = api.conexion;
        const METODO_API_AGREGAR = api.SINOJ.sistema.administracion.zonas.ObtenerZonas;
        let urlApi = SERVIDOR + METODO_API_AGREGAR;
        // craeamos la peticion con el formulario 
        //console.log('statusSeccion::' + urlApi);
        let peticionAPI = {};
        peticionAPI.esPrueba = false;
        peticionAPI.conInactivos = false;
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        /* comun.SeEstaCargandoInformacion(true); */
        axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(mensajeError);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                        //console.log("ejecuto bien :: cargarZonasRegistradas");
                        this.zonasCamposCompletos = respuesta.data.Zonas;
                        this.zonaDbAzonaObj(this.zonasCamposCompletos);
                    }
                    /* comun.SeEstaCargandoInformacion(false); */
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
        ); 
      },
      zonaDbAzonaObj: function(zonas) {
          let polygonos = [];
          let zonasTmp = [];
          if(zonas.length > 0) {
              zonas.forEach(z => {
                  let zona = {};
                  zona.Folio = z.ZonaId;
                  zona.Nombre = z.Nombre;
                  zona.Color = `<i class="fas fa-square-full" style="color: ${z.Color}; font-size: 20px; border: 2px solid #000000;"></i>`;
                  zonasTmp.push(zona);
                  let polygono = this.polygonoDbApolygonoObj(z);
                  polygonos.push(polygono);
              });
              this.zonas = zonasTmp;
              this.$refs.RefMapaZonas.mostrarPoligonosAgregados(polygonos);
          }
          else {
              this.zonas = [];
              this.$refs.RefMapaZonas.mostrarPoligonosAgregados(polygonos);
          }
          this.polygonosDeZonasDB = polygonos;
          this.cargandoZonas = false;
      },
      polygonoDbApolygonoObj: function(zona) {
          const polygonos = zona.Poligonos;
          let polygonoObj = {};
          let listaCoordPolygonoObj = [];
          polygonos.forEach(p => {
              let coordenadas = [p.Coordenada.Latitud, p.Coordenada.Longitud];
              listaCoordPolygonoObj.push(coordenadas);
              polygonoObj.coordenadas = listaCoordPolygonoObj;
          });
          polygonoObj.color = zona.Color;
          return polygonoObj;
      },
      cargarNotificadoresRegistradasBD: function() {
            const SERVIDOR = api.conexion;
            const METODO_API = api.SINOJ.sistema.administracion.notificadores.ObtenerNotificadores;
            let urlApi = SERVIDOR + METODO_API;
            let peticionAPI = {
                ZonaId: null,
                Nombre: null,
                ApellidoPaterno: null,
                ApellidoMaterno: null,
                ConInactivos: false,
            };
            peticionAPI.esPrueba = false;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("cargarNotificadoresRegistradasBD::ejecuto bien:: ",respuesta.data);
                            this.listaDeNotificadoresBD = respuesta.data.Notificadores;

                            this.notififcadorBDaNotificadorObj();
                            /* this.$nextTick(() => {
                                this.$refs[this.REF_TABLA_NOTIFICADORES].cedulasAmostrarPorPagina = 4;
                            }); */
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        notififcadorBDaNotificadorObj: function() {
            let notificadores = [];
            this.listaDeNotificadoresBD.forEach(nBD => {
                let notificador = {};
                notificador.Folio = nBD.NotificadorId;
                notificador.Nombre = nBD.Usuario.Nombre;
                notificador.ApellidoPaterno = nBD.Usuario.ApellidoPaterno;
                notificador.ApellidoMaterno = nBD.Usuario.ApellidoMaterno;
                notificadores.push(notificador);
            });
            this.listaDeNotificadores = notificadores;
            this.cargandoNotificadores = false;
            if(this.mostrarFormulario && !this.cargandoZonas) {
                this.$nextTick(() => {
                    //console.log('elemento::',$("#" + this.ID_TABLA_NOTIFICADORES + 'seleccionarTodos'));
                    $("#" + this.ID_TABLA_NOTIFICADORES + 'seleccionarTodos').hide();
                });
            }
            //console.log('notififcadorBDaNotificadorObj::',this.listaDeNotificadores);
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'Array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        confirmacionCambioZonaANotificador:function(notificador, check) {
            const DATOS_NOMBRE = [notificador.Usuario.Nombre,notificador.Usuario.ApellidoPaterno,notificador.Usuario.ApellidoMaterno]; 
            const NOMBRE_COMPLETO = DATOS_NOMBRE.join(' ');
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `El notificador '${NOMBRE_COMPLETO}' ya esta asignado a la zona '${notificador.Zona.Nombre}', si continuas se reasignara su zona.<br>¿Desea continuar?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (!respuesta) {
                        //console.log('entro::a::cancel');
                        $('#' + check).trigger('click');
                    }
                }
            });
        },
        confirmarEliminarZona: function(zona) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Estas seguro/a que deseas eliminar la zona '${zona.Nombre}.<br>¿Deseas continuar?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => { debugger
                    if (respuesta) {
                        let peticion = {};
                        peticion.esPrueba = false;
                        peticion.Zona = zona;
                        this.eliminarZonaDB(peticion);
                    }
                }
            });
        },
        esJuzgadoMixto: function(area) { 
            const { AreaId } = area;
            let usuarioEsDeJuzgadoMixto = false;
            const JUZGADOS_MIXTOS = Object.values(enumeraciones.sinoj.juzgadosMixtos);
            if(this.campoRequeridoEsValido(JUZGADOS_MIXTOS)) {
                usuarioEsDeJuzgadoMixto = JUZGADOS_MIXTOS.some(jz => jz == AreaId);
            }
            return usuarioEsDeJuzgadoMixto;
        },
        asignarPuntoDeInicioMapa: function() {
            if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area) && !this.cargoAreaDeUsuario) {
                this.cargoAreaDeUsuario = true;
                const ES_JUZGADO_MIXTO = this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);
                if(ES_JUZGADO_MIXTO) {
                    switch(this.$store.state.Login_Usuario.Area.AreaId) {
                        case enumeraciones.sinoj.juzgadosMixtos.Pabellon:
                            this.posicionOrigenMapa = enumeraciones.sinoj.juzgadosMixtosPuntosInicio.Pabellon
                        break;
                        case enumeraciones.sinoj.juzgadosMixtos.Pabellon:
                            this.posicionOrigenMapa = enumeraciones.sinoj.juzgadosMixtosPuntosInicio.Calvillo
                        break;
                        case enumeraciones.sinoj.juzgadosMixtos.Pabellon:
                            this.posicionOrigenMapa = enumeraciones.sinoj.juzgadosMixtosPuntosInicio.RinconDeRomos
                        break;
                        case enumeraciones.sinoj.juzgadosMixtos.Pabellon:
                            this.posicionOrigenMapa = enumeraciones.sinoj.juzgadosMixtosPuntosInicio.JesusMaria
                        break;
                        default:
                            this.posicionOrigenMapa = [21.878305650330997,-102.29601653410975];
                        break;
                    }
                    this.mapaInicio.contRender ++;
                }
            }
        }
        /* ,
        mostrarNotSeleccionados: function() {
            console.log('watxh::',this.notificadoresSeleccionados);
        } */
  }/* ,
  watch: {
      notificadoresSeleccionados() {
          this.mostrarNotSeleccionados();
      }
  } */,
  watch: {
      '$store.state.Login_Usuario.Area':  function() { 
            this.asignarPuntoDeInicioMapa();
        }
  },
  created() {
      this.cargarZonasRegistradas();
      this.asignarPuntoDeInicioMapa();
  },
  computed: {
      Zonas() {
          return this.zonas;
      }
  }
}
</script>
<style scoped>
#modal-confirmar-add-marcador .modal-lg {
    max-width: 30% !important;
}

#modal-confirmar-add-marcador .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-confirmar-add-marcador .modal-dialog {
    position: relative;
    top: 40%;
    transform: translateY(-50%);
}

#modal-mapa-expandido .modal-lg {
    max-width: 100% !important;
    padding: 0 0 0 1em !important;
}

#modal-mapa-expandido .modal-header {
    background-color: rgb(36, 34, 34);
    border: none;
}

#modal-mapa-expandido-formulario .modal-lg {
    max-width: 100% !important;
    padding: 0 0 0 1em !important;
}

#modal-mapa-expandido-formulario .modal-header {
    background-color: rgb(36, 34, 34);
    border: none;
}


.opcion-expandir-mapa {
    cursor: pointer;
    font-size: 1.5em;
}

.opcion-expandir-mapa:hover {
    cursor: pointer;
    font-size: 2em;
    font-weight: bold;
}

#btn-cerrar-formulario-alta-zona i {
    color: rgb(197, 13, 13) !important;
}
#contendor-principal-zonas .card-header {
    background-color: rgb(70, 70, 70);
}

#contendor-principal-zonas .card-body {
    background-color: rgb(49, 49, 49);
}

#contendor-principal-zonas .card {
    border: 1px solid rgb(129, 129, 129) !important;
}

#encabezados-tp {
    margin-bottom: 1em;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

#contenedor-administracion-zonas div {
    margin-top: 1.5em;
}

#contenedor-zonas {
    display: flex;
    justify-content: center;
}

#contenedor-mapa {
    height: 400px;
    border: 3px solid #000;
}

#contenedor-mapa-expandido {
    height: 560px;
    border: 3px solid #000;
}

#contenedor-mapa-expandido-formulario {
    height: 560px;
    border: 3px solid #000;
}

.btn-sm {
    width: 100px;
    height: 30px;
    padding: 0;
    cursor: pointer;
}

.btn-block {
    cursor: pointer;
}

.btn-primary {
    color: white;
    background-color: rgb(36, 34, 34);
    border-color: white;
}

.btn-primary:hover {
    color: white;
    background-color: black;
    border-color: white;
}

.btn-primary:focus {
    color: white;
    background-color: black;
    border-color: white;
    box-shadow: none;
}

.trazado-zonas-acciones {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.leaflet-container.crosshair-cursor-enabled {
  cursor: crosshair;
}

input[type="color"] {
	-webkit-appearance: none;
	border: none;
	width: 32px;
	height: 32px;
}
input[type="color"]::-webkit-color-swatch-wrapper {
	padding: 0;
}
input[type="color"]::-webkit-color-swatch {
	border: none;
}

.mapa {
  width: 100%;
  height: 100%;
}

.btn-xs {
    color: white;
    background-color: rgb(53, 48, 48);
    border-color: black;
    width: 100%;
    border-radius: 4px;
    height: 40px;
    cursor: pointer;
    text-align: left;
}

.btn-xs:hover, .btn-xs:focus{
    color: white;
    background-color: rgb(46, 42, 42);
    border-color: black;
    width: 100%;
    border-radius: 4px;
    height: 40px;
    cursor: pointer;
    text-align: left;
}

.contenedor-ver-direccionCompleta {
    color: white;
    background-color: rgb(32, 31, 31);
   /*  width: 100%;
    height: 100%; */
    padding: 1em;
    border: 2px solid black;
} 

#inputColorZona {
    cursor: pointer;
}

.contenedor-zonas-vacias {
    background-color: rgb(36, 34, 34);
    height: 40px;
    margin-top: 3px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contenedor-cargando {
    background-color: rgb(36, 34, 34);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

#encabezado-contenedor-contenido {
  background-color: rgb(44, 43, 43);
  padding: 10px;
}


</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Administracion/Zonas/CZonas.vue